const sliders = () => {

    if ($('.main-slider').length > 0) {
        var sliderTimer = 4000;
        var $mainSlider = $('.main-slider');

        $mainSlider
            .slick({
                arrows: true,
                dots: true,
                rows: 0,
                autoplay: true,
                autoplaySpeed: sliderTimer,
                pauseOnFocus: false,
                pauseOnHover: false,
                fade: false,
                prevArrow: '<button type="button" class="slick-prev"><i class="las la-angle-left"></i></button>',
                nextArrow: '<button type="button" class="slick-next"><i class="las la-angle-right"></i></button>'
            })
    }

    if ($('.blog-slider').length > 0) {
        var sliderTimer = 5000;
        var $blogSlider = $('.blog-slider');

        $blogSlider
            .slick({
                slidesToShow: 3,
                arrows: true,
                dots: false,
                autoplay: true,
                autoplaySpeed: sliderTimer,
                pauseOnFocus: false,
                pauseOnHover: false,
                fade: false,
                prevArrow: '<button type="button" class="slick-prev"><i class="las la-angle-left"></i></button>',
                nextArrow: '<button type="button" class="slick-next"><i class="las la-angle-right"></i></button>',

                responsive: [
                    {
                        breakpoint: 1030,
                        settings: {
                          slidesToShow: 2,
                          arrows: true,
                          dots: false
                        }
                    },
                    {
                      breakpoint: 630,
                      settings: {
                        slidesToShow: 1,
                        arrows: false,
                        dots: true
                      }
                    }
                    // You can unslick at a given breakpoint now by adding:
                    // settings: "unslick"
                    // instead of a settings object
                  ]
            })
    }


    if ($('.gallery-slider').length > 0) {
        var $gallerySlider = $('.gallery-slider');

        $gallerySlider
            .slick({
                slidesToShow: 1,
                mobileFirst: true,
                arrows: true,
                dots: false,
                autoplay: true,
                autoplaySpeed: 4000,
                pauseOnFocus: false,
                pauseOnHover: false,
                fade: false,
                prevArrow: '<button type="button" class="slick-prev"><i class="las la-angle-left"></i></button>',
                nextArrow: '<button type="button" class="slick-next"><i class="las la-angle-right"></i></button>',

                responsive: [
                    {
                      breakpoint: 830,
                        settings: {
                          slidesToShow: 2,
                        }
                    },
                    {
                      breakpoint: 1030,
                      settings: "unslick"
                    }
                    // You can unslick at a given breakpoint now by adding:
                    // settings: "unslick"
                    // instead of a settings object
                  ]
            })
    }

    if ($('.popular-artist-slider').length > 0) {
        var $artistSlider = $('.popular-artist-slider');

        $artistSlider
            .slick({
                slidesToShow: 1,
                mobileFirst: true,
                arrows: true,
                dots: false,
                autoplay: true,
                autoplaySpeed: 4000,
                pauseOnFocus: false,
                pauseOnHover: false,
                fade: false,
                prevArrow: '<button type="button" class="slick-prev"><i class="las la-angle-left"></i></button>',
                nextArrow: '<button type="button" class="slick-next"><i class="las la-angle-right"></i></button>',

                responsive: [
                  {
                    breakpoint: 830,
                    settings: {
                      slidesToShow: 3,
                    }
                },
                  {
                    breakpoint: 1030,
                    settings: {
                      slidesToShow: 3,
                    }
                },
                {
                  breakpoint: 1266,
                  settings: {
                    slidesToShow: 5,
                  }
                },
                ]
            })
    }

    if ($('.partners').length > 0) {
        var $partnersSlider = $('.partners');

        $partnersSlider
            .slick({
                slidesToShow: 1,
                mobileFirst: true,
                arrows: false,
                dots: false,
                autoplay: true,
                autoplaySpeed: 2000,
                pauseOnFocus: false,
                pauseOnHover: false,
                fade: false,

                responsive: [
                    {
                      breakpoint: 600,
                      settings: "unslick"
                    }
                    /*{
                      breakpoint: 600,
                      settings: {
                        slidesToShow: 2,
                      }
                    },

                    {
                      breakpoint: 800,
                      settings: {
                        slidesToShow: 3,
                      }
                    },

                    {
                      breakpoint: 1000,
                      settings: {
                        slidesToShow: 4,
                      }
                    },

                    {
                      breakpoint: 1200,
                      settings: {
                        slidesToShow: 6,
                      }
                    }*/
                    // You can unslick at a given breakpoint now by adding:
                    // settings: "unslick"
                    // instead of a settings object
                  ]
            })
    }


    if ($('.slider-3').length > 0) {
      var $slider3 = $('.slider-3');

      $('.slider-3')
      .slick({
        slidesToShow: 1,
        dots: false,
        autoplay: false,
        mobileFirst: true,
        prevArrow: '<button type="button" class="slick-prev"><i class="las la-angle-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next"><i class="las la-angle-right"></i></button>',

        responsive: [
          {
            breakpoint: 1030,
            settings: {
              slidesToShow: 2,
            }
        },
        {
          breakpoint: 1266,
          settings: {
            slidesToShow: 3,
          }
        },

          ]
    })

  }

  if ($('.slider-5').length > 0) {
    var $slider5 = $('.slider-5');

    $('.slider-5')
    .slick({
      slidesToShow: 1,
      dots: false,
      autoplay: false,
      mobileFirst: true,
      prevArrow: '<button type="button" class="slick-prev"><i class="las la-angle-left"></i></button>',
      nextArrow: '<button type="button" class="slick-next"><i class="las la-angle-right"></i></button>',

      responsive: [
        {
          breakpoint: 1030,
          settings: {
            slidesToShow: 2,
          }
      },
      {
        breakpoint: 1266,
        settings: {
          slidesToShow: 5,
        }
      },

        ]
  })

}

  $('.slider-picture').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      arrows: false,
      asNavFor: '.slider-picture-thumbs',

      responsive: [
        {
          breakpoint: 1030,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            arrows: true,
            fade: false,
            swipe: false,
            swipeToSlide: false,
            touchMove: false,
            draggable: false,            
            prevArrow: '<button type="button" class="slick-prev"><i class="las la-angle-left"></i></button>',
            nextArrow: '<button type="button" class="slick-next"><i class="las la-angle-right"></i></button>'
          }
        },
      ]
  });

  let sliderPicuterThumbs = $('.slider-picture-thumbs').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.slider-picture',
      dots: false,
      centerMode: false,
      focusOnSelect: true,
      vertical: true,
      arrows: false
  });

  $('.slider-picture-thumbs-nav').click(function(){
    sliderPicuterThumbs.slick('slickNext');
  })

}

const slider4 = () => {
  if ($('.slider-4').length > 0) {
    var $slider4 = $('.slider-4');

    $slider4
        .slick({
          slidesToShow: 1,
          dots: false,
          autoplay: false,
          mobileFirst: true,
          prevArrow: '<button type="button" class="slick-prev"><i class="las la-angle-left"></i></button>',
          nextArrow: '<button type="button" class="slick-next"><i class="las la-angle-right"></i></button>',

          responsive: [
              {
                  breakpoint: 800,
                  settings: {
                    slidesToShow: 2,
                  }
              },
              {
                breakpoint: 1266,
                settings: "unslick"
              }
              // You can unslick at a given breakpoint now by adding:
              // settings: "unslick"
              // instead of a settings object
            ]
      })

  }
}

module.exports = {
    sliders,
    slider4
};